import s from '../collegesItem.module.css'
import {useState} from "react";
import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import {workingHours} from "@api"

import { InputSelect, InputNew } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";

const ModalAddTime = ({setActive, userId, update}) => {
  const addAlert = useAddAlert();

  const [loading, setLoading] = useState(false);
  const [errorsList, setErrorsList] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [weekDay, setWeekDay] = useState("");
  
  const daysOfWeek = [
    {label: 'Понедельник', value: '0'},
    {label: 'Вторник', value: 1},
    {label: 'Среда', value: 2},
    {label: 'Четверг', value: 3},
    {label: 'Пятница', value: 4},
    {label: 'Суббота', value: 5},
    {label: 'Воскресение', value: 6},
  ];

  const [bindWeekDay] = useInputNew({
    name: "week_day",
    value: weekDay,
    onChange: setWeekDay,
    options: daysOfWeek,
    onError: setErrorsList,
    validate: showErrors,
    errorText: "Выберите день недели",
  });

 
  const [bindStartTime] = useInputNew({
    name: "start_time",
    type: 'time',
    value: startTime,
    onChange: setStartTime,
    onError: setErrorsList,
    placeholder: "Время начала",
    validate: showErrors,
    errorText: "Введите время начала",
  });
  const [bindEndTime] = useInputNew({
    name: "end_time",
    type: 'time',
    value: endTime,
    onChange: setEndTime,
    placeholder: "Время окончания",
    onError: setErrorsList,
    validate: showErrors,
    errorText: "Введите время окончания",
  });

  const save = () => {
    setShowErrors(true);
    if (errorsList.valid) {
        setLoading(true);
        const formData = new FormData();
        formData.append("start_time", startTime);
        formData.append("end_time", endTime);
        formData.append("week_day", weekDay);
        formData.append("user_id", userId);
        
        workingHours.create(formData)
        .then(res => {
            if (res?.status == 200 || res?.data?.status === "success") {
                addAlert({ text: 'Часы успешно добавлены'})
                setActive(false)
                update("workHours")
                // window.location.reload();
            } else {
                addAlert({ title: 'Ошибка', text: 'При добавлении произошла ошибка', type: 'error' })
                setActive(false)
            }
        })
        .finally((res)=>{
            setLoading(false);
        })
    }
  };

  return <div className="modal_departments">
    <h2 className="modal__title">Добавить часы работы</h2>
    <div className={s.body}>
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>День недели</span>
          <InputSelect className={s.input} {...bindWeekDay} style={{width:'100%'}} />
          
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Время начала</span>
          <InputNew className={s.input} {...bindStartTime} style={{width:'100%'}}/>

          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Время окончания</span>
          <InputNew className={s.input} {...bindEndTime} style={{width:'100%'}}/>
          <Button disabled={loading} onClick={save}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddTime;